import { useGeneratePrintTagPayload } from "./useGeneratePrintTagPayload";

export default useGeneratePrintTagPayload;
